import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { REACT_APP_SITE_NAME } from '../constants/config'

const mapStateToProps = state => ({
    ...state.common,
})

const mapDispatchToProps = dispatch => ({
})

class Pending extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {

        return (<div className="main">
            <div className="main-wrap">
                <div className="Sigma">
                    <h2 className='AltTitle'>Lgoin failed</h2>
                    <div>If this error persists please contact {REACT_APP_SITE_NAME} customer service. </div>
                </div>
            </div>
        </div>)

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Pending))